(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $17173029c3fdd71e$exports = {};
$17173029c3fdd71e$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 45 45\" shape-rendering=\"crispEdges\"><path fill=\"#fff\" d=\"M0 0h45v45H0z\"/><path stroke=\"#000\" d=\"M4 4.5h7m1 0h1m3 0h1m3 0h3m1 0h1m2 0h3m1 0h2m1 0h7m-37 1h1m5 0h1m3 0h4m1 0h1m1 0h5m3 0h1m2 0h1m1 0h1m5 0h1m-37 1h1m1 0h3m1 0h1m2 0h3m2 0h4m1 0h4m3 0h1m3 0h1m1 0h3m1 0h1m-37 1h1m1 0h3m1 0h1m1 0h1m1 0h2m1 0h1m2 0h1m1 0h1m1 0h1m2 0h6m1 0h1m1 0h3m1 0h1m-37 1h1m1 0h3m1 0h1m1 0h4m2 0h2m1 0h2m2 0h1m1 0h1m1 0h1m1 0h2m1 0h1m1 0h3m1 0h1m-37 1h1m5 0h1m1 0h3m3 0h1m2 0h1m1 0h1m1 0h2m2 0h1m4 0h1m5 0h1m-37 1h7m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h7m-29 1h5m4 0h1m3 0h1m1 0h2m1 0h1m-27 1h1m3 0h1m1 0h4m2 0h1m1 0h4m3 0h2m4 0h1m1 0h5m2 0h1m-36 1h1m2 0h2m1 0h3m1 0h1m1 0h2m3 0h1m2 0h1m1 0h1m1 0h5m2 0h2m1 0h1m-36 1h4m2 0h2m6 0h2m1 0h2m1 0h1m2 0h2m1 0h2m3 0h2m1 0h1m-34 1h2m5 0h4m1 0h1m1 0h5m1 0h1m1 0h2m1 0h1m4 0h2m1 0h2m-35 1h4m1 0h1m2 0h2m1 0h1m1 0h1m1 0h2m1 0h4m3 0h2m1 0h3m1 0h4m-36 1h1m5 0h1m1 0h1m3 0h6m2 0h3m1 0h3m1 0h1m2 0h2m-34 1h1m2 0h1m2 0h1m3 0h2m1 0h5m3 0h4m2 0h1m1 0h1m1 0h4m-35 1h1m4 0h1m1 0h1m1 0h1m1 0h4m2 0h1m2 0h2m1 0h2m1 0h4m1 0h2m1 0h1m-34 1h1m1 0h1m1 0h2m2 0h1m3 0h3m1 0h1m1 0h1m1 0h2m1 0h1m4 0h3m1 0h3m-34 1h1m2 0h1m2 0h1m2 0h1m1 0h2m1 0h2m5 0h1m3 0h1m1 0h1m2 0h1m2 0h1m-36 1h1m2 0h1m2 0h7m1 0h1m1 0h1m1 0h1m1 0h8m5 0h1m-33 1h2m8 0h4m2 0h1m1 0h6m1 0h1m5 0h1m1 0h2m-35 1h3m2 0h3m1 0h2m2 0h2m1 0h1m3 0h2m1 0h1m4 0h3m1 0h2m-35 1h2m1 0h1m3 0h6m2 0h2m4 0h1m1 0h1m1 0h1m1 0h3m1 0h2m-32 1h1m4 0h2m1 0h3m1 0h1m1 0h1m1 0h2m1 0h1m2 0h1m1 0h1m1 0h3m1 0h4m-35 1h4m1 0h1m6 0h3m2 0h1m3 0h2m4 0h3m1 0h2m1 0h1m-35 1h1m1 0h1m2 0h2m3 0h8m3 0h2m1 0h1m4 0h3m1 0h4m-37 1h1m2 0h3m1 0h1m4 0h1m1 0h1m3 0h2m3 0h1m2 0h3m3 0h1m-31 1h3m1 0h2m1 0h3m3 0h1m5 0h1m1 0h1m3 0h3m1 0h2m-31 1h2m6 0h1m1 0h1m1 0h5m2 0h1m1 0h2m1 0h1m2 0h2m2 0h3m-36 1h2m1 0h1m2 0h1m1 0h5m4 0h2m1 0h2m5 0h6m1 0h1m1 0h1m-29 1h1m2 0h1m1 0h1m1 0h4m4 0h1m1 0h4m3 0h1m2 0h1m-36 1h7m1 0h2m3 0h1m1 0h1m1 0h2m1 0h2m1 0h2m3 0h1m1 0h1m1 0h1m-33 1h1m5 0h1m2 0h2m1 0h1m3 0h4m1 0h4m1 0h1m1 0h1m3 0h3m1 0h1m-37 1h1m1 0h3m1 0h1m1 0h2m8 0h2m1 0h2m5 0h7m1 0h1m-37 1h1m1 0h3m1 0h1m3 0h1m1 0h2m2 0h3m2 0h1m1 0h1m2 0h6m1 0h4m-37 1h1m1 0h3m1 0h1m2 0h1m2 0h3m1 0h1m1 0h1m1 0h1m2 0h1m1 0h2m2 0h2m-31 1h1m5 0h1m4 0h1m5 0h2m1 0h2m2 0h1m1 0h2m1 0h2m1 0h1m1 0h2m-36 1h7m1 0h1m4 0h1m1 0h1m1 0h1m1 0h5m3 0h1m1 0h3m1 0h4\"/></svg>";


const $eedf330dc27473e1$var$euLegalGuaranteeUrl = "https://europa.eu/youreurope/citizens/consumers/shopping/guarantees/index_sv.htm";
const $eedf330dc27473e1$var$widgetClass = "reach-svd-checkout-guarantee";
const $eedf330dc27473e1$var$qrSvg = (0, (/*@__PURE__*/$parcel$interopDefault($17173029c3fdd71e$exports))).replace(/<\?xml[^>]*>/, "").replace(/<!DOCTYPE[^>]*>/, "");
function $eedf330dc27473e1$var$createGuaranteeLink() {
    const link = document.createElement("a");
    link.className = $eedf330dc27473e1$var$widgetClass;
    link.href = $eedf330dc27473e1$var$euLegalGuaranteeUrl;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.hidden = true;
    link.setAttribute("aria-label", "Lagstadgad garanti (EU)");
    link.innerHTML = `
    ${$eedf330dc27473e1$var$qrSvg}
    <span>Lagstadgad garanti (EU)</span>
  `;
    return link;
}
function $eedf330dc27473e1$var$checkoutIsStacked(cart) {
    const sidebar = cart.querySelector(".ec-cart__sidebar");
    const body = cart.querySelector(".ec-cart__body");
    if (!(sidebar instanceof HTMLElement) || !(body instanceof HTMLElement)) return true;
    return body.getBoundingClientRect().top >= sidebar.getBoundingClientRect().bottom - 8;
}
function $eedf330dc27473e1$var$alignBelowNastaLine(link, host) {
    link.style.marginTop = "0px";
    const caption = host.querySelector(".ec-cart-step--order-confirmation .ec-cart-step__body");
    const label = link.querySelector("span");
    if (!(caption instanceof HTMLElement) || !(label instanceof HTMLElement)) return;
    const hostTop = host.getBoundingClientRect().top;
    const linkBox = link.getBoundingClientRect();
    if (Math.abs(linkBox.top - hostTop) > 12) return;
    const labelOffset = label.getBoundingClientRect().top - linkBox.top;
    const offset = caption.getBoundingClientRect().top - hostTop - labelOffset;
    link.style.marginTop = `${Math.max(0, Math.round(offset))}px`;
}
function $eedf330dc27473e1$var$purchasePage() {
    const page = document.querySelector(".ec-store__cart-page, .ec-store__checkout-page");
    if (!(page instanceof HTMLElement)) return null;
    const cart = page.querySelector(".ec-cart");
    return cart instanceof HTMLElement ? cart : page;
}
function $eedf330dc27473e1$export$bb15ea8b3f3c227b() {
    const store = document.querySelector("#store");
    if (!(store instanceof HTMLElement)) return;
    const existing = document.querySelector(`.${$eedf330dc27473e1$var$widgetClass}`);
    const link = existing instanceof HTMLAnchorElement ? existing : $eedf330dc27473e1$var$createGuaranteeLink();
    const sync = ()=>{
        const page = $eedf330dc27473e1$var$purchasePage();
        if (page == null) {
            link.hidden = true;
            link.style.marginTop = "0px";
            link.classList.remove(`${$eedf330dc27473e1$var$widgetClass}--stacked`);
            if (link.parentElement !== store) store.appendChild(link);
            return;
        }
        link.hidden = false;
        const cart = page.classList.contains("ec-cart") ? page : null;
        const steps = cart?.querySelector(".ec-cart__steps");
        const stacked = cart != null && $eedf330dc27473e1$var$checkoutIsStacked(cart);
        if (stacked && steps instanceof HTMLElement) {
            link.style.marginTop = "";
            link.classList.add(`${$eedf330dc27473e1$var$widgetClass}--stacked`);
            if (link.previousElementSibling !== steps) steps.insertAdjacentElement("afterend", link);
            return;
        }
        link.classList.remove(`${$eedf330dc27473e1$var$widgetClass}--stacked`);
        if (link.parentElement !== page) page.appendChild(link);
        if (cart != null) $eedf330dc27473e1$var$alignBelowNastaLine(link, cart);
    };
    let scheduled = false;
    const scheduleSync = ()=>{
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(()=>{
            scheduled = false;
            sync();
        });
    };
    const observe = ()=>{
        new MutationObserver(scheduleSync).observe(store, {
            childList: true,
            subtree: true
        });
        scheduleSync();
    };
    const whenEcwidPageApiReady = (callback)=>{
        if (window.Ecwid?.OnPageLoaded) {
            callback();
            return;
        }
        const startedAt = Date.now();
        const intervalId = window.setInterval(()=>{
            if (window.Ecwid?.OnPageLoaded) {
                window.clearInterval(intervalId);
                callback();
                return;
            }
            if (Date.now() - startedAt > 15000) window.clearInterval(intervalId);
        }, 50);
    };
    whenEcwidPageApiReady(()=>{
        window.Ecwid?.OnPageLoaded.add(scheduleSync);
        window.Ecwid?.OnPageSwitch.add(()=>{
            window.setTimeout(scheduleSync, 50);
            window.setTimeout(scheduleSync, 300);
        });
        observe();
        window.addEventListener("resize", scheduleSync);
    });
}


const $12637c04bc11267f$var$WRAPPER_CLASS = "reach-product-description-readmore";
const $12637c04bc11267f$var$BODY_CLASS = "reach-product-description-readmore__body";
const $12637c04bc11267f$var$TOGGLE_CLASS = "reach-product-description-readmore__toggle";
const $12637c04bc11267f$var$MIN_PREVIEW_PX = 96;
function $12637c04bc11267f$var$findDescriptionTarget() {
    const module = document.querySelector(".ecwid-productBrowser .product-details-module.product-details__product-description");
    if (module instanceof HTMLElement) {
        const content = module.querySelector(":scope > .product-details-module__content") || module.querySelector(".product-details-module__content");
        if (content instanceof HTMLElement) return content;
        return module;
    }
    const fallback = document.querySelector(".ecwid-productBrowser .product-details__product-description");
    return fallback instanceof HTMLElement ? fallback : null;
}
function $12637c04bc11267f$var$findGallery() {
    const selectors = [
        ".ecwid-productBrowser .product-details__pictures",
        ".ecwid-productBrowser .product-details-pictures",
        ".ecwid-productBrowser .details-gallery",
        ".ecwid-productBrowser .product-details__image"
    ];
    for (const selector of selectors){
        const element = document.querySelector(selector);
        if (element instanceof HTMLElement) return element;
    }
    return null;
}
function $12637c04bc11267f$var$flattenNestedAccordions(root) {
    root.querySelectorAll("details").forEach((nested)=>{
        nested.open = true;
        nested.querySelector(":scope > summary")?.remove();
    });
}
function $12637c04bc11267f$var$unwrapLegacyAccordion() {
    document.querySelectorAll(".reach-product-description-accordion").forEach((details)=>{
        const parent = details.parentElement;
        if (!parent) return;
        while(details.firstChild){
            const child = details.firstChild;
            if (child instanceof HTMLElement && child.tagName === "SUMMARY") {
                child.remove();
                continue;
            }
            parent.insertBefore(child, details);
        }
        details.remove();
    });
}
function $12637c04bc11267f$var$absorbLooseContent(container, wrap) {
    const body = wrap.querySelector(`.${$12637c04bc11267f$var$BODY_CLASS}`);
    if (!(body instanceof HTMLElement)) return;
    Array.from(container.childNodes).forEach((node)=>{
        if (node !== wrap) body.appendChild(node);
    });
}
function $12637c04bc11267f$var$ensureReadMore(container) {
    const existing = container.querySelector(`:scope > .${$12637c04bc11267f$var$WRAPPER_CLASS}`);
    if (existing instanceof HTMLElement) {
        $12637c04bc11267f$var$absorbLooseContent(container, existing);
        return existing;
    }
    const wrap = document.createElement("div");
    wrap.className = $12637c04bc11267f$var$WRAPPER_CLASS;
    const body = document.createElement("div");
    body.className = $12637c04bc11267f$var$BODY_CLASS;
    while(container.firstChild)body.appendChild(container.firstChild);
    const toggle = document.createElement("button");
    toggle.type = "button";
    toggle.className = $12637c04bc11267f$var$TOGGLE_CLASS;
    toggle.textContent = "L\xe4s mer...";
    wrap.appendChild(body);
    wrap.appendChild(toggle);
    container.appendChild(wrap);
    toggle.addEventListener("click", ()=>{
        const expanded = wrap.classList.toggle("is-expanded");
        toggle.textContent = expanded ? "Visa mindre" : "L\xe4s mer...";
        $12637c04bc11267f$var$updateClamp(wrap);
    });
    return wrap;
}
function $12637c04bc11267f$var$updateClamp(wrap) {
    const body = wrap.querySelector(`.${$12637c04bc11267f$var$BODY_CLASS}`);
    if (!(body instanceof HTMLElement)) return;
    const toggle = wrap.querySelector(`.${$12637c04bc11267f$var$TOGGLE_CLASS}`);
    if (wrap.classList.contains("is-expanded")) {
        wrap.classList.remove("is-clamped");
        body.style.maxHeight = "";
        if (toggle instanceof HTMLElement) toggle.hidden = false;
        return;
    }
    const gallery = $12637c04bc11267f$var$findGallery();
    body.style.maxHeight = "";
    wrap.classList.remove("is-clamped");
    let available = $12637c04bc11267f$var$MIN_PREVIEW_PX;
    if (gallery) {
        available = Math.floor(gallery.getBoundingClientRect().bottom - body.getBoundingClientRect().top - 28);
        if (available < $12637c04bc11267f$var$MIN_PREVIEW_PX) available = $12637c04bc11267f$var$MIN_PREVIEW_PX;
    }
    if (body.scrollHeight > available + 8) {
        wrap.classList.add("is-clamped");
        body.style.maxHeight = `${available}px`;
        if (toggle instanceof HTMLElement) toggle.hidden = false;
        return;
    }
    if (toggle instanceof HTMLElement) toggle.hidden = true;
}
function $12637c04bc11267f$var$applyProductDescriptionReadMore() {
    $12637c04bc11267f$var$unwrapLegacyAccordion();
    const description = $12637c04bc11267f$var$findDescriptionTarget();
    if (!description) return;
    const module = description.closest(".product-details-module") instanceof HTMLElement ? description.closest(".product-details-module") : description;
    module.querySelectorAll(".product-details-module__title").forEach((title)=>title.remove());
    module.querySelectorAll(".product-details-module__content--collapsed").forEach((content)=>{
        content.classList.remove("product-details-module__content--collapsed");
    });
    $12637c04bc11267f$var$flattenNestedAccordions(description);
    const wrap = $12637c04bc11267f$var$ensureReadMore(description);
    $12637c04bc11267f$var$flattenNestedAccordions(wrap);
    $12637c04bc11267f$var$updateClamp(wrap);
}
function $12637c04bc11267f$var$onProductPageLoaded() {
    requestAnimationFrame(()=>{
        $12637c04bc11267f$var$applyProductDescriptionReadMore();
        window.setTimeout($12637c04bc11267f$var$applyProductDescriptionReadMore, 80);
        window.setTimeout($12637c04bc11267f$var$applyProductDescriptionReadMore, 300);
        window.setTimeout($12637c04bc11267f$var$applyProductDescriptionReadMore, 800);
    });
}
function $12637c04bc11267f$var$whenEcwidPageApiReady(callback) {
    if (window.Ecwid?.OnPageLoaded) {
        callback();
        return;
    }
    const startedAt = Date.now();
    const intervalId = window.setInterval(()=>{
        if (window.Ecwid?.OnPageLoaded) {
            window.clearInterval(intervalId);
            callback();
            return;
        }
        if (Date.now() - startedAt > 15000) window.clearInterval(intervalId);
    }, 50);
}
function $12637c04bc11267f$export$ef4f7d47fa1a363b() {
    $12637c04bc11267f$var$whenEcwidPageApiReady(()=>{
        const handlePage = (page)=>{
            if (page.type !== "PRODUCT") return;
            $12637c04bc11267f$var$onProductPageLoaded();
        };
        window.Ecwid?.OnPageLoaded.add(handlePage);
        window.Ecwid?.OnPageSwitch.add(handlePage);
        window.addEventListener("resize", ()=>{
            const wrap = document.querySelector(`.${$12637c04bc11267f$var$WRAPPER_CLASS}`);
            if (wrap instanceof HTMLElement) $12637c04bc11267f$var$updateClamp(wrap);
        });
        $12637c04bc11267f$var$onProductPageLoaded();
    });
}


// The shared wrapper still injects a site-wide floating QR for this store.
// SVD only shows that QR inside the cart and checkout view.
function $c2848ebcf924d7cd$var$removeEuLegalGuarantee() {
    document.querySelectorAll(".reach-eu-legal-guarantee").forEach((node)=>node.remove());
}
$c2848ebcf924d7cd$var$removeEuLegalGuarantee();
new MutationObserver($c2848ebcf924d7cd$var$removeEuLegalGuarantee).observe(document.documentElement, {
    childList: true,
    subtree: true
});
function $c2848ebcf924d7cd$var$loadReachWrapperScript(url) {
    return new Promise((resolve, reject)=>{
        const inject = ()=>{
            const script = document.createElement("script");
            script.src = url;
            script.onload = ()=>resolve();
            script.setAttribute("id", "reach-init-script");
            script.onerror = (error)=>reject(error);
            const parent = document.body ?? document.head ?? document.documentElement;
            parent.appendChild(script);
        };
        // svd.se includes this file from <head>, so document.body is still null.
        // The store node and xReachStore("id=store") are parsed later. Wait until
        // that call has been queued, then inject widget.js.
        if (document.body) inject();
        else document.addEventListener("DOMContentLoaded", inject, {
            once: true
        });
    });
}
let $c2848ebcf924d7cd$var$scriptLoaded = false;
// Then load external script
// loadReachWrapperScript("http://localhost:1234/widget.js?95806261")
$c2848ebcf924d7cd$var$loadReachWrapperScript("https://store.loyative.com/widget.js?95806261").then(()=>{
    $c2848ebcf924d7cd$var$scriptLoaded = true;
    $c2848ebcf924d7cd$var$pendingXReachStoreCalls.forEach(({ args: args, resolve: resolve, reject: reject }, index)=>{
        try {
            const result = window.xReachStore?.(...args);
            const id = $c2848ebcf924d7cd$var$extractIdFromParams(...args);
            $c2848ebcf924d7cd$var$injectReachToolsPanelContainer(id);
            $c2848ebcf924d7cd$var$injectPurchaseCancellationFooter();
            window.xReachCategories?.(`id=reach--categories`);
            window.xReachMiniCart?.(`id=reach--mini-cart`);
            resolve(result);
        } catch (error) {
            reject(error);
        }
    });
    (0, $12637c04bc11267f$export$ef4f7d47fa1a363b)();
    (0, $eedf330dc27473e1$export$bb15ea8b3f3c227b)();
// Continue with code that depends on the loaded script
}).catch((error)=>{
    console.error("Failed to load script:", error);
});
// Create a queue to store calls before the script is loaded
const $c2848ebcf924d7cd$var$pendingXReachStoreCalls = [];
let $c2848ebcf924d7cd$var$originalXProductBrowser = null;
window.xReachStore = (...args)=>{
    return new Promise((resolve, reject)=>{
        $c2848ebcf924d7cd$var$pendingXReachStoreCalls.push({
            args: args,
            resolve: resolve,
            reject: reject
        });
    });
};
function $c2848ebcf924d7cd$var$injectReachToolsPanelContainer(id) {
    const reachToolsPanelDiv = document.createElement("div");
    reachToolsPanelDiv.setAttribute("id", "reach--tools-panel");
    reachToolsPanelDiv.style.visibility = "hidden";
    reachToolsPanelDiv.style.display = "flex";
    reachToolsPanelDiv.style.justifyContent = "space-between";
    reachToolsPanelDiv.style.alignItems = "flex-start";
    reachToolsPanelDiv.style.width = "100%";
    reachToolsPanelDiv.style.marginBottom = "0.5em";
    reachToolsPanelDiv.style.gap = "24px";
    reachToolsPanelDiv.classList.add("reach--tools-panel");
    const categoriesDiv = document.createElement("div");
    categoriesDiv.setAttribute("id", "reach--categories");
    categoriesDiv.style.flexGrow = "1";
    const reachMiniCartDiv = document.createElement("div");
    reachMiniCartDiv.setAttribute("id", "reach--mini-cart");
    reachToolsPanelDiv.appendChild(categoriesDiv);
    reachToolsPanelDiv.appendChild(reachMiniCartDiv);
    document.querySelector(`#${id}`)?.prepend(reachToolsPanelDiv);
}
function $c2848ebcf924d7cd$var$injectPurchaseCancellationFooter() {
    if (document.querySelector(".reach-purchase-cancellation-footer") != null) return;
    const footer = document.createElement("p");
    footer.className = "reach-purchase-cancellation-footer";
    footer.innerHTML = '\xc5ngrar du ditt k\xf6p, <a href="https://www.loyative.com/regret">klicka h\xe4r</a>.';
    document.body.appendChild(footer);
}
function $c2848ebcf924d7cd$var$extractIdFromParams(...args) {
    const id = args.map((arg)=>{
        if (typeof arg !== "string") return undefined;
        const possiblyId = arg.split("id=")[1].split("&")[0];
        return possiblyId;
    }).filter((x)=>x != null)[0];
    return id;
}

})();
//# sourceMappingURL=index.js.map
